import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  constructor(public service: DashboardService, public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private router: Router,private _snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.appuser=JSON.parse(localStorage.getItem('userdata'));
    this.payload.email=this.appuser.email;

    setTimeout(() => {
      if(this.appuser)
      this.getQuestions();
    },5)

    console.log('questions',this.questions)
  }


  confirm_password:""
  hasError=false;
  pin_error:boolean=false;
  appuser: any={
    account_activation_requested:'0'
  };
  questions: any={
    question1:'',
    question2:'',
    question3:'',
  };
  payload: any={
    email:'',
    password:'',
    newPassword:''
  }

  onSubmit=()=>{
    this.hasError=false;
      if(this.payload.password=='' || this.payload.newPassword=='')
       this.hasError=true;
      else if(this.payload.newPassword!=this.confirm_password){
        this.alertSnackBar('New password do not match','Validation failed')
        this.hasError=true;
      }
      if(this.hasError)
       (Swal as any).fire({
        title: 'Validation Alert',
        text: 'Kindly complete the highlighted fields',
        icon: 'warning',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      })
      else{
        Swal.showLoading();;
        if(this.appuser.account_activation_requested=='1')
        this.answerQuestions();
        else
        this.changePassword();
      }
  }
  //trigger the snackbar
  alertSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getQuestions(){
    this.service.resetPasswordRequest({email:this.appuser.email})
    .toPromise()
    .then((response : any)=>{
      if(response['responseCode']=='000')
        this.questions=response['profile'][0];
    })
    .catch((err: any)=>{
      this.questions=null;
    })
  }

  answerQuestions(){
    this.service.addSecurityQuestions({email:this.payload.email,answer1:this.payload.answer1,answer2:this.payload.answer2,answer3:this.payload.answer3})
    .toPromise()
    .then((response: any)=>{
           if(response['responseCode']=='000'){
            this.appuser.account_activation_requested=0;
            this.changePassword();
           }
           else{
             (Swal as any).fire({
               title:'Failed',
               text:'Failed to set security questions',
               icon:'error'
             });
           }
    });
  }

  changePassword(){
    this.service.changePassword(this.payload)
        .toPromise()
        .then((response: any)=>{
            if(response.hasOwnProperty('responseCode') && response.responseCode=='000')
            {
              (Swal as any).fire({
                title: 'Successful',
                text: 'Password Changed successfully!',
                icon: 'success',
                showConfirmButton: true,
              }).then((result:any)=>{
                 if(result.isConfirmed)
                 this.dialogRef.close({ event: 'close', data: {} });
                 this.appuser.reset_requested=0;
                 localStorage.setItem('userdata',JSON.stringify(this.appuser));
                 this.dialogRef.close();
              });
            }
            else if(response.hasOwnProperty('responseCode') && response.responseCode=='098'){
              (Swal as any).fire({
                title: 'Failed',
                text: 'Invalid Password!',
                icon: 'warning',
              });
            }
            else
            (Swal as any).fire({
              title: 'Failed',
              text: 'Pin Chane Failed!',
              icon: 'error',
            });
        }).catch(error=>{
          (Swal as any).fire({
            title: 'Failed',
            text: 'Password Change Failed!',
            icon: 'error',
          });
        })
  }
}
